import React from 'react';
import PropTypes from 'prop-types';

function ExternalLinkIcon() {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      className="tds2-agentforce-modal__markdown-cta-external"
    >
      <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
      <polyline points="15 3 21 3 21 9" />
      <line x1="10" y1="14" x2="21" y2="3" />
    </svg>
  );
}

export function isSalesforceLink(href) {
  if (!href) return false;
  return /salesforce\.com|salesforce\.example|force\.com|copilot|playground|aiCopilot|agentbuilder/i.test(href);
}

export default function MarkdownLinkCta({ href, label }) {
  const showSalesforceIcon = isSalesforceLink(href);
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="tds2-agentforce-modal__markdown-cta"
    >
      {showSalesforceIcon ? (
        <span
          aria-hidden="true"
          className="tds2-agentforce-modal__markdown-cta-icon tds2-agentforce-modal__markdown-cta-icon--salesforce"
        />
      ) : null}
      <span className="tds2-agentforce-modal__markdown-cta-label">{label}</span>
      <ExternalLinkIcon />
    </a>
  );
}

MarkdownLinkCta.propTypes = {
  href: PropTypes.string.isRequired,
  label: PropTypes.node.isRequired,
};
